<template>
  <v-container fluid>

    <v-dialog transition="dialog-bottom-transition" max-width="900" v-model="modemModelsDialog">
      <v-card>
        <v-card-title class="primary lighten white--text">
          Modelos de modem
          <v-spacer></v-spacer>
          <v-btn text class="litte white--text" @click="modemModelsDialog = false">
            <v-icon white>mdi-window-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form ref="ModemModelForm" v-model="modemModelFormValid" lazy-validation>
            <v-row class="mt-2">
              <v-col cols="12" sm="3">
                <v-text-field v-model="modemModel.name" label="Nome" :rules="rulesRequired" required />
              </v-col>
              <v-col cols="12" sm="3">
                <v-select v-model="modemModel.supplyOrigin" :items="supply" label="Fornecedor"
                  :rules="rulesRequired" required :disabled="isModemModelSupplyOriginLocked"
                  @change="onModemModelSupplyOriginChange" />
              </v-col>
              <v-col cols="12" sm="3">
                <v-select v-model="modemModel.deviceCommunicationType" :items="modemModelConnectionTypes"
                  label="Tipo de comunicação" :rules="rulesRequired" required
                  :disabled="isModemModelConnectionTypeLocked || !modemModel.supplyOrigin" />
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field v-model="modemModel.observation" label="Observação" />
              </v-col>
              <v-col cols="12" class="d-flex justify-end">
                <v-btn v-if="modemModel.id" text color="grey" class="mr-2" :disabled="modemModelsLoading"
                  @click="resetModemModelForm">
                  Cancelar
                </v-btn>
                <v-btn text color="primary" :loading="modemModelsLoading" @click="saveModemModel">
                  {{ modemModel.id ? 'Salvar' : 'Adicionar' }}
                  <v-icon right>{{ modemModel.id ? 'mdi-content-save' : 'mdi-plus' }}</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
          <v-data-table :headers="modemModelHeaders" :items="modemModels" :loading="modemModelsLoading"
            no-data-text="Sem modelos para exibir">
            <template v-slot:item.observation="{ item }">
              {{ item.observation || "Sem observação" }}
            </template>
            <template v-slot:item.actions="{ item }">
              <div class="modem-model-actions">
                <v-btn icon color="primary" @click="editModemModel(item)">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon color="error" :disabled="item.quantity > 0" @click="confirmDeleteModemModel(item)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </div>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog transition="dialog-bottom-transition" max-width="800" v-model="modalFlag">
      <template v-slot:default>
        <v-card>
          <v-overlay absolute style="opacity: 0.8" :value="isWaitingLoraResponse">
            <v-progress-circular indeterminate color="primary" :size="30"></v-progress-circular>
          </v-overlay>
          <v-card-title class="primary lighten white--text">{{ modalTitle }}
            <v-spacer></v-spacer>

            <v-btn text class="litte white--text" @click="FSM_Modem('close-modal')">
              <v-icon white>mdi-window-close</v-icon>

            </v-btn>
          </v-card-title>
          <v-card-text>

            <v-tabs v-model="tabModems">
              <v-tab v-for="selectedTab in tabItems" :key="selectedTab">
                {{ selectedTab }}
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tabModems">
              <v-tab-item key="1">
                <v-form v-model="validForm" lazy-validation ref="FormModem">
                  <v-overlay absolute style="opacity: 0.8" :value="isWaitingLoraResponse">
                  <v-progress-circular indeterminate color="primary" :size="30"></v-progress-circular>
                </v-overlay>
                <v-row>
                    <v-col cols="12" v-if="getCurrentUserRank !== 'Franqueado'">
                    <v-autocomplete v-model="modem.id_franchisee" :items="listFranchisees" item-text="name"
                      item-value="id" required label="Franqueado" dense outlined hide-details :rules="rulesRequired" />
                  </v-col>
                  <v-col cols="6">
                      <v-select v-model="modem.model_id" :items="modemModelSelectOptions" label="Modelo - Conexão" type="text"
                        :rules="rulesRequired" required @change="onModemModelChange" />
                    </v-col>
                    <v-col cols="6" v-if="getModemDeviceCommunicationType(modem) === 'LORAWAN' || getModemDeviceCommunicationType(modem) === 'LTE'">
                      <v-select v-model="modem.brokerSupply" :items="brokerSupplyOptions" label="Fornecedor broker"
                        type="text" :rules="rulesRequired" required />
                    </v-col>
                    <v-col cols="6" v-else-if="getModemDeviceCommunicationType(modem) === 'LORA_GATEWAY'">
                      <v-text-field value="Interno" label="Fornecedor broker" readonly />
                    </v-col>
                  </v-row>
                  <v-row v-if="selectedModemModel">
                    <v-col cols="12">
                      <div class="modem-model-summary">
                        <div class="modem-model-summary__header">
                          <v-icon small color="primary">mdi-router-wireless</v-icon>
                          <span class="modem-model-summary__title">{{ selectedModemModel.name }}</span>
                        </div>
                        <div class="modem-model-summary__grid">
                          <div class="modem-model-summary__item">
                            <span class="modem-model-summary__label">Fornecedor</span>
                            <span class="modem-model-summary__value">
                              {{ getSupplyLabel(selectedModemModel.supplyOrigin) || '—' }}
                            </span>
                          </div>
                          <div class="modem-model-summary__item">
                            <span class="modem-model-summary__label">Conexão</span>
                            <span class="modem-model-summary__value">
                              {{ getConnectionType(selectedModemModel.deviceCommunicationType) || '—' }}
                            </span>
                          </div>
                          <div class="modem-model-summary__item modem-model-summary__item--wide">
                            <span class="modem-model-summary__label">Observação</span>
                            <span class="modem-model-summary__value">
                              {{ selectedModemModel.observation || 'Sem observação' }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row v-show="modem.model_id">
                    <v-col cols="12">
                      <v-text-field label="Nome do Modem" placeholder="Nome" v-model="modem.name" :rules="rulesRequired" required></v-text-field>
                    </v-col>
  
                    <v-col cols="12" v-if="getModemSupplyOrigin(modem) === 'IETECH' && getModemDeviceCommunicationType(modem) === 'WIFI'">
                      <v-text-field label="ID do Modem" placeholder="ID" v-model="modem.id" :readonly="true"
                        @click:append="generateID" append-icon="mdi-update" :rules="rulesRequired" required/>
                    </v-col>
                    <v-col cols="6" v-else-if="getModemDeviceCommunicationType(modem) === 'LTE'">
                      <v-text-field label="IMEI" placeholder="15 dígitos" v-model="modem.id" :readonly="isEditingModem"
                        :rules="rulesLteImei" required maxlength="15" />
                    </v-col>
                    <v-col cols="6" v-else-if="getModemDeviceCommunicationType(modem) === 'LORA_GATEWAY'">
                      <v-text-field label="DevEUI" placeholder="16 caracteres hexadecimais" v-model="modem.id"
                        :readonly="isEditingModem" :rules="rulesModemId" required :maxlength="isEditingModem ? 8 : 16" />
                    </v-col>
                    <v-col cols="6" v-else>
                      <v-text-field label="ID do Modem" placeholder="ID" v-model="modem.id" :readonly="isEditingModem" :rules="rulesModemId" required/>
                    </v-col>
                    <v-col cols="6">
                      <v-switch v-model="modem.isActive" label="Modem Ativo" color="success" inset></v-switch>
                    </v-col>
                    <v-col v-if="modalTitle === 'Edição de Modem'" sm="12" cols="12" style="
                            background: #1976D205;
                            border-radius: 15px;
                            border: 1px solid #ccc!important;
                        ">
                      <h2 style="text-align: center;padding-bottom: 10px">{{ sectorCurrentModemLoading ||
                        sectorCurrentModem.name ? "Setor" : "Não existe setor vinculado a esse modem!" }}</h2>
                      <v-divider />
                      <v-row v-if="sectorCurrentModem.name">
                        <v-col cols="12">
                          <v-text-field :loading="sectorCurrentModemLoading" background-color="white" outlined
                            label="Nome" v-model="sectorCurrentModem.name" :readonly="true">
                          </v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field :loading="unitCurrentSectorLoading" background-color="white" outlined
                            label="Unidade" v-model="unitCurrentSector.name" :readonly="true">
                          </v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-alert v-if="modemCreationFailed" dense outlined type="error">
                      <strong>{{ modemErrorMsg }}</strong> Tente novamente ou entre em contato com o administrador.
                    </v-alert>
                  </v-row>
                </v-form>
              </v-tab-item>
              <v-tab-item key="2">
                <br />
                <v-overlay absolute style="opacity: 0.8" :value="isWaitingLoraResponse">
                  <v-progress-circular indeterminate color="primary" :size="30"></v-progress-circular>
                </v-overlay>
                <h3>Alertas de Telemetria</h3>
                <v-row>
                  <v-col cols="11" sm="3">
                    <v-checkbox label="Bateria Fraca" prepend-icon="mdi-battery-charging-low"
                      v-model="modem.alertLowBaterry_IsActive">
                    </v-checkbox>
                  </v-col>
                  <v-col cols="11" sm="3">
                    <v-checkbox label="Falta de Sinal" prepend-icon="mdi-signal-off"
                      v-model="modem.alertUnsignal_IsActive">
                    </v-checkbox>
                  </v-col>
                  <v-col cols="11" sm="3">
                    <v-checkbox label="Não Variação" prepend-icon="mdi-repeat-off"
                      v-model="modem.alertNoVariation_IsActive">
                    </v-checkbox>
                  </v-col>
                  <v-col cols="11" sm="3">
                    <v-checkbox label="Sem Decodificação" prepend-icon="mdi-xml"
                      v-model="modem.alertUndecoded_IsActive">
                    </v-checkbox>
                  </v-col>
                </v-row>
                <v-divider style="margin-bottom: 10px"></v-divider>

              </v-tab-item>
              <v-tab-item key="3" v-if="modalTitle === 'Edição de Modem'">
                <v-overlay absolute style="opacity: 0.8" :value="isWaitingLoraResponse">
                  <v-progress-circular indeterminate color="primary" :size="30"></v-progress-circular>
                </v-overlay>
                <v-row>
                  <v-col cols="10">
                    <h3>Atualizações em tempo real</h3>
                  </v-col>
                  <v-col cols="2">
                    <v-btn class="mx-2" fab dark small :color="playTelemetryButton ? 'red' : 'green'"
                      @click="startListenerData()">

                      <v-icon v-if="playTelemetryButton">
                        mdi-stop
                      </v-icon>
                      <v-icon v-else>
                        mdi-play
                      </v-icon>
                    </v-btn></v-col>
                  <v-col cols="12">
                    <div class="telemetry-status-panel" :class="{ 'is-active': playTelemetryButton }">
                      <div class="telemetry-status-header">
                        <v-chip small label :color="telemetryStatusColor" text-color="white">
                          {{ playTelemetryButton ? 'Ao vivo' : 'Pausado' }}
                        </v-chip>
                        <span class="telemetry-status-text">{{ telemetryStatusLabel }}</span>
                      </div>
                      <v-progress-linear :value="telemetryCountdownProgress" :color="telemetryStatusColor" rounded
                        height="8"></v-progress-linear>
                    </div>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field label="Última Leitura" :value="modemListener.lastReading" placeholder="Sem leituras"
                      type="text" readonly></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field label="Último Dado" :value="modemListener.lastData" placeholder="Sem dados"
                      type="text" readonly></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-data-table :headers="headersTelemetry" :items="readingsSnapashot" :items-per-page="5"
                      class="elevation-1"></v-data-table>
                    <!-- {{  readingsSnapashot }} -->
                  </v-col>
                </v-row>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>

          <v-card-actions class="justify-end">

            <v-btn text @click="FSM_Modem('save-modal', { modem: modem, index: modemIndex })">Salvar</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
    <v-row>
      <v-col cols="12">
        <v-card style="border-radius: 0 0 15px 15px;">
          <v-overlay absolute style="opacity: 0.8" :value="loadingModens">
            <v-progress-circular indeterminate color="primary" :size="50" />
          </v-overlay>
          <v-data-table :items="filteredItems" :headers="headers" :footer-props="{
            'items-per-page-options': [5, 10, 20, 30]
          }" no-data-text="Sem modems para exibir">

            <template v-slot:top>
              <v-toolbar flat color="white" class="rounded-xl">
                <v-toolbar-title class="title-displays">Modems</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn @click="openModemModelsDialog" text color="primary" class="mr-2"
                  v-if="getCurrentUserRank !== 'Franqueado'">
                  Modelos
                  <v-icon>mdi-format-list-bulleted</v-icon>
                </v-btn>
                <v-btn @click="generateReport" text color="success" class="mr-2" :loading="loadingModens">
                  <v-icon>mdi-file-excel</v-icon>
                  Gerar Relatório
                </v-btn>
                <v-btn @click="FSM_Modem('create')" text color="primary" v-if="getCurrentUserRank !== 'Franqueado'">
                  Adicionar
                  <v-icon>add</v-icon>
                </v-btn>
              </v-toolbar>
              <!-- Busca -->
              <v-row style="justify-content: space-between">
                <v-text-field style="width: 80%; padding: 1em" class="px-4" prepend-icon="search" label="Busca"
                  v-model="searchText"></v-text-field>
                <v-select hint="Buscar nessa coluna" persistent-hint style="width: 20%; padding: 1em"
                  v-model="columnToSearch" :items="columnsToChoose" return-object single-line></v-select>
              </v-row>
            </template>
            <template v-slot:item.status="{ item }">
              <v-row>
                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" :color="getStatusColor(item.lastReading)">circle</v-icon>
                  </template>
                  <span>
                    <p>Verde: Enviou hoje</p>
                    <p>Amarelo: Enviou nesta semana</p>
                    <p>Vermelho: Não enviou a mais de uma semana</p>
                  </span>
                </v-tooltip>
                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on"
                      :color="getStatusVariationColor(item.lastVariationAt)">circle</v-icon>
                  </template>
                  <span>
                    <p>{{ getDateVariation(item.lastVariationAt) }}</p>
                    <p>Verde: Variou hoje</p>
                    <p>Amarelo: Variou nesta semana</p>
                    <p>Vermelho: Não Variou a mais de uma semana</p>
                  </span>
                </v-tooltip>
                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on"
                      :color="getStatusDecodingColor(item.lastErrorDecodingAt)">circle</v-icon>
                  </template>
                  <span>
                    <p>{{ getDateVariation(item.lastErrorDecodingAt) }}</p>
                    <p>Verde: Falha na decodificação a mais de uma semana</p>
                    <p>Amarelo: Falha na decodificação nesta semana</p>
                    <p>Vermelho: Falha na decodificação hoje</p>
                  </span>
                </v-tooltip>
              </v-row>
            </template>
            <template v-slot:item.lastBattery="{ item }">
              {{ checarBateria(item) }}
            </template>
            <template v-slot:item.lastReadingDateSort="{ item }">
              {{ stringDate(item) || "Sem leituras" }}
            </template>
            <template v-slot:item.lastVariationAtSort="{ item }">
              {{ stringDateVariation(item) || "Sem variações" }}
            </template>
            <template v-slot:item.lastData="{ item }">
              {{ item.lastData || "Sem dados" }}
            </template>
            <template v-slot:item.isActive="{ item }">
              <v-chip :color="(item.isActive !== false) ? 'success' : 'error'" small>
                {{ (item.isActive !== false) ? 'Ativado' : 'Desativado' }}
              </v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" color="primary" style="font-weight: bold"
                    :disabled="processingItem !== null && processingItem !== item" :loading="processingItem === item"
                    outlined>
                    <v-icon small>
                      mdi-text-box-multiple-outline
                    </v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item link v-for="(line, index) in listActions" :key="index" :value="index">
                    <v-list-item-title @click="selectAction(item, line.value)">
                      {{ line.title }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>

          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ModemsScript from './ModemsScript';
export default ModemsScript;
</script>


<style scoped lang="scss">
.title-displays {
  font-size: 25px;
  padding-top: 8px;
  padding-bottom: 8px;
}

.div-loading {
  background-color: #1976d2;
  padding: 20px;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  width: 250px;
}

.span-loading {
  font-size: 15px;
  margin-top: 3px;
}

.telemetry-status-panel {
  border: 1px solid rgba(25, 118, 210, 0.18);
  border-radius: 8px;
  padding: 12px 14px;
  background: #f7fbff;
}

.telemetry-status-panel.is-active {
  background: #f4fbf7;
  border-color: rgba(76, 175, 80, 0.22);
}

.telemetry-status-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
}

.telemetry-status-text {
  color: #4f5b67;
  font-size: 13px;
  line-height: 1.4;
  text-align: right;
}

.modem-model-actions {
  align-items: center;
  display: flex;
  gap: 4px;
  justify-content: flex-start;
  white-space: nowrap;
}

.modem-model-summary {
  background: #f7fbff;
  border: 1px solid rgba(25, 118, 210, 0.18);
  border-radius: 10px;
  padding: 14px 16px;
}

.modem-model-summary__header {
  align-items: center;
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
}

.modem-model-summary__title {
  color: #1f2933;
  font-size: 15px;
  font-weight: 600;
}

.modem-model-summary__grid {
  display: grid;
  gap: 10px 16px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.modem-model-summary__item {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.modem-model-summary__item--wide {
  grid-column: 1 / -1;
}

.modem-model-summary__label {
  color: #6b7785;
  font-size: 11px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.modem-model-summary__value {
  color: #334155;
  font-size: 14px;
  line-height: 1.4;
}
</style>
